import type Phaser from 'phaser';
import { resetOverlay } from './overlay.js';

export function transitionTo(
  scene: Phaser.Scene,
  targetKey: string,
  data?: object,
): void {
  const mgr = scene.scene.manager;
  // If we're already on the target scene, do nothing. Otherwise a stale
  // onMessage handler from a previous scene re-triggering a transition would
  // stop + restart the target, firing its SHUTDOWN cleanup (which can leave
  // the colyseus room and bounce the user back to the lobby).
  if (mgr.isActive(targetKey)) return;
  resetOverlay();
  const targets: string[] = [];
  for (const s of mgr.scenes) {
    const key = s.scene.settings.key;
    if (key !== targetKey && mgr.isActive(key)) targets.push(key);
  }
  for (const key of targets) {
    mgr.stop(key);
  }
  mgr.start(targetKey, data);
}
